import * as constants from './constants';

export const formatStatus = (status) => {
  const map = {
    [constants.taskStatuses.ACTIVE]: 'In Progress',
    [constants.taskStatuses.COMPLETED]: 'Completed',
    [constants.taskStatuses.PENDING]: 'Pending',
  };

  return map[status];
};

export const userLabelByStatus = (status) => {
  const map = {
    [constants.taskStatuses.ACTIVE]: 'Assigned To',
    [constants.taskStatuses.PENDING]: 'Assigned To',
    [constants.taskStatuses.COMPLETED]: 'Completed By',
  };

  return map[status];
};

export const dateLabelByStatus = (status) => {
  const map = {
    [constants.taskStatuses.ACTIVE]: 'Due Date',
    [constants.taskStatuses.PENDING]: 'Due Date',
    [constants.taskStatuses.COMPLETED]: 'Completed Date',
  };

  return map[status];
};
